var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 4a7.47 7.47 0 00-.252 1.5H3.5V8h7.271c.198.715.5 1.387.886 2H3.5v8.5h17v-5.429a7.467 7.467 0 001.5-.73V20H3a1 1 0 01-1-1V4h8.771z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15a1 1 0 110 2H6a1 1 0 110-2h4zM18 2.75c.161 0 .308.057.424.173l.075.092a.59.59 0 01.097.33v2.06h2.058A.587.587 0 0121.25 6a.59.59 0 01-.097.33l-.076.093a.584.584 0 01-.423.172h-2.058v2.058A.586.586 0 0118 9.25a.591.591 0 01-.331-.097l-.093-.076a.584.584 0 01-.172-.423V6.596h-2.058a.583.583 0 01-.422-.173h-.001A.586.586 0 0114.75 6c0-.161.057-.308.173-.424l.092-.075a.59.59 0 01.33-.097h2.06V3.346A.586.586 0 0118 2.75z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.309.008A6 6 0 0124 6l-.008.309A6 6 0 0118 12l-.309-.008a6 6 0 01-5.683-5.683L12 6a6 6 0 016-6l.309.008zM18 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    fill: "currentColor"
  })));
}
SvgAddCard.displayName = 'AddCard';
export default SvgAddCard;